<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
              <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                @change="getDataBranch(Company)"
                hide-details
                label="บริษัท"
                class="ma-2"
              ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                hide-details
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                hide-details
                label="แผนก"
                class="ma-2"
              ></v-select>
            </v-sheet>
          </v-col>
        </v-row>
          <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- วัน -->
              <v-select
                v-model="day"
                :items="dayName"
                dense
                outlined
                hide-details
                label="วัน"
                class="ma-2"
              ></v-select>
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-icon
                color="#871B12"
                size="30"
                @click="getData()"
                >mdi-calendar-search</v-icon
              >
              <v-icon
                color="#871B12"
                size="30"
                @click="clear()"
                >mdi-refresh</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>
          <!-- Dialog export / import -->
          <v-col cols="12">
            <v-btn
              color="green"
              class="white--text"
              @click="dialogAdd = true"
            >
              เพิ่มข้อมูล
              <v-icon right dark> mdi-plus </v-icon>
            </v-btn>
            <v-btn
            :loading="loading3"
              :disabled="loading3"
              color="blue-grey"
              class="ma-2 white--text"
              @click="(loader = 'loading3'), exportEmpInfo()">
              <v-icon left>mdi-download</v-icon>
                Export Data
            </v-btn>
            <!-- <v-btn color="yellow-light" depressed @click="dialogImport = true">
              <v-icon left>mdi-import</v-icon>
              Manage Data By Excel.xls
            </v-btn> -->
             <v-btn color="yellow-light" @click="getData()">
                reload
            </v-btn>
          </v-col>

          <!-- ADD -->
        <v-dialog v-model="dialogAdd" max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">สร้างเวลาเข้า ออกงาน สำหรับ Admin</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <span>*กรุณาเลือกพนักงาน</span>
                 <v-row>
                    <v-col cols="10">
                      <v-autocomplete
                      v-model="profile"
                      :items="dataItemEmployee"
                      :rules="nameRules"
                      dense
                      outlined
                      clear-icon="mdi-close-circle"
                      prepend-icon="mdi-account-star"
                    ></v-autocomplete>
                    </v-col>
                    <v-col cols="2">
                    </v-col>
                </v-row>

              <!-- <v-container fluid> -->
                <v-divider class="mx-0" style="background-color: #ffffff"></v-divider>
                <!-- <form> -->
                  <v-select
                    v-model="formAdd.masShiftTypeCode"
                    :items="itemsShiftType"
                    :rules="nameRules"
                    prepend-icon="mdi-beach"
                    label="เลือก กะ"
                    clearable
                    clear-icon="mdi-close-circle"
                    outlined
                    dense
                  ></v-select>
                  <v-divider
                    class="mx-0"
                    style="background-color: #ffffff"
                  ></v-divider>

                  <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- วัน -->
              <v-select
                v-model="formAdd.day"
                :items="dayName"
                dense
                outlined
                hide-details
                label="วัน"
                class="ma-2"
              ></v-select>
              <!-- เดือน -->
              <v-select
                v-model="formAdd.month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="formAdd.year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
            </v-sheet>
          </v-col>
        </v-row>

        <v-container fluid>
    <v-row>
      <v-col cols="2" class="pa-0 ma-0">
        <v-subheader>เวลาเข้างาน: </v-subheader>
      </v-col>
      <v-col cols="6">
        <vue-timepicker
          format="HH:mm"
          v-model="formAdd.checkInStartStamp"
          @change="changeHandlerformAdd1"
        >
        </vue-timepicker>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="2" class="pa-0 ma-0">
        <v-subheader>เวลาออกงาน: </v-subheader>
      </v-col>
      <v-col cols="6">
        <vue-timepicker
            format="HH:mm"
            v-model="formAdd.checkInEndStamp"
            @change="changeHandlerformAdd2"
          >
          </vue-timepicker>
      </v-col>
    </v-row>
  </v-container>

                  <!-- start date -->
                  <v-divider style="background-color: #ffffff"></v-divider>
                  <v-col
                    cols="12"
                  >
                    <v-textarea
                      outlined
                      v-model="formAdd.remark"
                      name="input-7-4"
                      label="หมายเหตุ"
                    ></v-textarea>
                  </v-col>
                  <v-divider style="background-color: #ffffff"></v-divider>
              <v-row>
              <v-col class="text-left">

              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialogAdd = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>

              </v-col>
              <v-col class="text-right">
                <v-btn
                  elevation="2"
                  x-large
                  color="success"
                  :disabled="!valid_add"
                  text
                  @click="submit(formAdd)"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ส่ง
                </v-btn>
              </v-col>
              </v-row>
              </v-container>

              <!-- </v-form> -->

              <!-- end -->
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end add -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-text>
                <v-text-field
                v-model="searchAll"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.DateCheckIN`]="{ item }">
                    {{item.checkInDay}}/{{item.checkInMonth}}/{{item.checkInYear}}
                  </template>
                  <template v-slot:[`item.editCheckout`]="{ item }">
                    <v-btn
                      color="orange"
                      @click="getDataById(item)"
                    > แก้ไข
                      <v-icon> mdi-account-edit </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <v-dialog v-model="dialog"  width="500">
              <v-toolbar color="indigo" dark>
                <v-toolbar-title>แก้ไขเวลาเข้า-ออก งาน</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="getData(), (dialog = false)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card>
                <v-card>
                  <v-col cols="12">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr style="background-color: #1b437c">
                          <th class="text-left">รายการ</th>
                          <th class="text-left">รายละเอียด</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>รหัสพนักงาน</td>
                          <td>{{ formUpdate.empCode }}</td>
                        </tr>
                        <tr>
                          <td>ชื่อพนักงาน</td>
                          <td>{{ formUpdate.empFull_NameTH }}</td>
                        </tr>
                        <tr>
                          <td>วันที่</td>
                          <td>{{ formUpdate.checkInYear }}-{{ formUpdate.checkInMonth }}-{{ formUpdate.checkInDay}}</td>
                        </tr>
                        <tr>
                          <td>ประเภทกะ</td>
                          <td>{{ formUpdate.masShiftTypeName }}</td>
                        </tr>
                        <tr>
                          <td>เวลาเข้างาน</td>
                          <td>
                            <vue-timepicker
                              format="HH:mm"
                              v-model="formUpdate.checkInStartStamp"
                              @change="changeHandler1"
                            >
                            </vue-timepicker>
                            <!-- <v-text-field
                                v-model="formUpdate.checkInStartStamp"
                              ></v-text-field> -->
                            {{ formUpdate.checkInStartStamp }}
                            {{ formUpdate.lateStatus }} ({{
                              formUpdate.lateTime
                            }})
                          </td>
                        </tr>
                        <tr>
                          <td>เวลาเลิกงาน</td>
                          <td>
                            <vue-timepicker
                              format="HH:mm"
                              v-model="formUpdate.checkInEndStamp"
                              @change="changeHandler2"
                            >
                            </vue-timepicker>
                            <!-- <v-text-field
                                v-model="formUpdate.checkInEndStamp"
                              ></v-text-field> -->
                              {{ formUpdate.checkInEndStamp }}
                              {{ formUpdate.earlyStatus }}(
                              {{ formUpdate.earlyTime }})
                              </td>
                        </tr>
                        <tr>
                          <td>หมายเหตุ</td>
                          <td>
                            <v-text-field
                            :rules="nameRules"
                            required
                                v-model="formUpdate.checkInRemark"
                              ></v-text-field>
                              </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  </v-col>
                </v-card>

                <v-divider style="background-color: #ffffff"></v-divider>

                <v-card-actions>
                  <v-col class="text-center pt-0 pb-10">
                    <v-btn
                    :disabled="!formUpdate.checkInRemark"
                      color="success"
                      elevation="2"
                      dark
                      @click="
                        updateCheckINOUT(formUpdate)
                      "
                    >
                      บันทึกข้อมูล
                    </v-btn>
                  </v-col>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <div v-if="!dataReady" class="text-center">
              <v-progress-linear
            color="deep-purple accent-4"
            indeterminate
            rounded
          >
          </v-progress-linear>
          <h6 class="purple--text pa-2 font-weight-bold">
          กรุณารอ สักครู่
                  </h6>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import dayName from '../../../assets/master/Date/day.json'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
import moment from 'moment'

import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    VueTimepicker
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/ch_checkin/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'จัดการเวลาเข้าออกงาน',
          disabled: false,
          href: '/CheckINOUT/ManageCheckINOUT'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      // Dialog Config ADD EDIT DELETE IMPORT
      dialog: false,
      formAdd: [],
      dialogAdd: false,
      dataItemEmployee: [],
      itemsShiftType: [],
      valid_add: true,
      profile: '',
      dialogImport: false,
      nameRules: [(v) => !!v || 'กรุณาให้เหตุผลที่สมควร'],
      // END Dialog Config ADD EDIT DELETE
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      year: '',
      month: '',
      day: '',
      time: null,
      modal2: false,
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      // Data Table Config
      columns: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'วัน/เดือน/ปี', value: 'DateCheckIN' },
        { text: 'กะ', value: 'masShiftTypeName' },
        { text: 'เข้างาน', value: 'checkInStartStamp' },
        { text: 'ออกงาน', value: 'checkInEndStamp' },
        { text: 'จัดการ', value: 'editCheckout', sortable: false, align: 'center' }
      ],
      dataItem: [],
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      // End Data Table Config

      dataItemImport: [],
      formUpdate: [],
      center: {},
      // End Config Import
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      loading3: false
    }
  },
  async mounted () {
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()

    await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()
    this.dataReady = false
    // Get Data
    await this.getData()
    this.getEmployee()
    this.getShiftType()
  },
  methods: {
    async getData () {
      this.dataReady = false

      var Company = (this.Company === '' ? '' : '&masCompanyName=' + this.Company)
      var Branch = (this.Branch === '' ? '' : '&masBranchName=' + this.Branch)
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ข้อมูลใน Import
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "get?checkInDay=" +
            this.day +
            '&checkInMonth=' +
            this.getMonthThToINT(this.month) +
            '&checkInYear=' +
            this.year + Company + Branch + Department, {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    exportEmpInfo () {
      var tem = []
      this.dataItem.forEach((element) => {
        console.log(element)
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ปี': element.checkInYear,
          'เดือน': element.checkInMonth,
          'วัน': element.checkInDay,
          'รหัสกะ': element.masShiftTypeCode,
          'กะเข้างาน': element.masShiftTypeStartTime,
          'เวลาเข้างาน': element.checkInStartStamp,
          'สถานะสาย': element.lateStatus,
          'สาย(นาที)': element.lateTime,
          'กะเวลาออกงาน': element.masShiftTypeEndTime,
          'เวลาออกงาน': element.checkInEndStamp,
          'สถานะออกก่อน': element.earlyStatus,
          'ออกก่อน(นาที)': element.earlyTime,
          'สถานที่ทำงาน': element.location,
          'หมายเหตุ': element.checkInRemark
        }
        tem.push(s)
      })
      var info = XLSX.utils.json_to_sheet(tem)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
      XLSX.writeFile(wb, 'checkin_out.xls') // name of the file is 'book.xlsx'
    },
    async getDataById (item) {
      this.dataReady = false

      var Company = (this.Company === '' ? '' : '&masCompanyName=' + this.Company)
      var Branch = (this.Branch === '' ? '' : '&masBranchName=' + this.Branch)
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "get?" + 'empCode=' + item.empCode + '&checkInDay=' +
            this.day +
            '&checkInMonth=' +
            this.getMonthThToINT(this.month) +
            '&checkInYear=' +
            this.year + Company + Branch + Department, {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            this.formUpdate = response.data[0]
            this.formUpdate.remark = null
          }
          this.dialog = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
        })
    },
    changeHandler1 (eventData) {
    // eventData -> {data: {HH:..., mm:...}, displayTime: 'HH:mm'}
      console.log('eventData', eventData)
      console.log('eventData', eventData.displayTime)
      this.formUpdate.checkInStartStamp = eventData.displayTime
    },
    changeHandler2 (eventData) {
    // eventData -> {data: {HH:..., mm:...}, displayTime: 'HH:mm'}
      console.log('eventData', eventData)
      console.log('eventData', eventData.displayTime)
      this.formUpdate.checkInEndStamp = eventData.displayTime
    },
    changeHandlerformAdd1 (eventData) {
    // eventData -> {data: {HH:..., mm:...}, displayTime: 'HH:mm'}
      console.log('eventData', eventData)
      console.log('eventData', eventData.displayTime)
      this.formAdd.checkInStartStamp = eventData.displayTime
    },
    changeHandlerformAdd2 (eventData) {
    // eventData -> {data: {HH:..., mm:...}, displayTime: 'HH:mm'}
      console.log('eventData', eventData)
      console.log('eventData', eventData.displayTime)
      this.formAdd.checkInEndStamp = eventData.displayTime
    },
    async getEmployee () {
      this.dataItemEmployee = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_user/getList',
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          console.log('response.data', response.data)
          let rs = response.data
          // console.log(rs)
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            // s = d.empFull_NameTH
            s.value = d
            s.text = '[' + d.empCode + ']' + d.empFull_NameTH
            this.dataItemEmployee.push(s)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // this.formAdd.empCodeHeader = null
          console.log(error)
        })
    },
    async submit (formAdd) {
      let mstCode = formAdd.masShiftTypeCode
      let mstMonth = this.getMonthThToINT(formAdd.month)
      console.log('formAdd', formAdd)
      console.log('mstCode', mstCode.masShiftTypeCode)
      console.log('mstMonth', this.getMonthThToINT(formAdd.month))

      let ds = {
        empCode: this.profile.empCode,
        masShiftTypeCode: mstCode.masShiftTypeCode,
        checkInYear: formAdd.year,
        checkInMonth: mstMonth,
        checkInDay: formAdd.day,
        checkInEndStamp: formAdd.checkInEndStamp,
        checkInStartStamp: formAdd.checkInStartStamp,
        remark: formAdd.remark
      }
      console.log('ds', ds)
      await this.addData(ds)
    },
    async addData (ds) {
      console.log('insert', ds)
      await axios
        .post(
          this.DNS_IP + '/ch_checkin_checkout/add',
          ds
        )
        .then(async (response) => {
          this.$swal('เรียบร้อย', 'ลงเวาลาเข้าออกงานเรียบร้อย', 'success')
          this.dialogAdd = false
          await this.getData()
        })
      console.log('ลงเวาลาเข้าออกงานเรียบร้อย')
    },
    async getShiftType () {
      this.itemsShiftType = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/master_shift_type/get',
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          console.log('response.data', response.data)
          let rs = response.data
          // console.log(rs)
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            // s = d.empFull_NameTH
            s.value = d
            s.text = d.masShiftTypeName
            this.itemsShiftType.push(s)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // this.formAdd.empCodeHeader = null
          console.log(error)
        })
    },
    async updateCheckINOUT (item) {
      console.log('item', item)
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let ds = {
            checkInEndStamp: item.checkInEndStamp,
            earlyTime: '00:00',
            earlyStatus: 'ปกติ',
            endDate: item.masShiftTypeEndTime,
            checkInStartStamp: item.checkInStartStamp,
            startDate: item.masShiftTypeStartTime,
            lateStatus: 'ปกติ',
            lateTime: '00:00',
            checkInRemark: item.checkInRemark,
            LAST_USER: this.session.data.userName
          }
          let dp = {
            empCode: item.empCode,
            masShiftTypeCode: item.masShiftTypeCode,
            checkInStartStamp: item.checkInStamp,
            checkInStartEdit: item.checkInStartStamp,
            checkInEndStamp: item.checkOutStamp,
            checkInEndEdit: item.checkInEndStamp,
            checkInYear: item.checkInYear,
            checkInMonth: item.checkInMonth,
            checkInDay: item.checkInDay,
            CREATE_USER: this.session.data.userName,
            LAST_USER: this.session.data.userName,
            lateStatus: item.lateStatus,
            lateTime: item.lateTime,
            startDate: item.startDate,
            earlyTime: item.earlyTime,
            earlyStatus: item.earlyStatus,
            endDate: item.endDate,
            checkInRemark: item.checkInRemark
          }
          console.log('DS', ds)
          console.log('DP', dp)
          console.log('item.checkInId', item.checkInId)
          await axios.post(
            this.DNS_IP + '/ch_checkin/adjust_edit/' + item.checkInId,
            ds,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          await axios.post(
            this.DNS_IP + '/ch_checkin/insertToLog',
            dp,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูลเรียบร้อย', 'success')
              this.dialog = false
              await this.getData()
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function deleteDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_company/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          this.dataReady = true
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.text = d.masCompanyName
              s.value = d.masCompanyName
              d = s
              this.CompanyItem.push(d)
            }
          } else {
            this.CompanyItem = []
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.text = d.masBranchName
              s.value = d.masBranchName
              d = s
              this.BranchItem.push(d)
            }
          } else {
            this.BranchItem = []
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.text = d.masDepartmentName
              s.value = d.masDepartmentName
              d = s
              this.DepartmentItem.push(d)
            }
          } else {
            this.DepartmentItem = []
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    },
    async clear () {
      await this.getData()
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}

@import 'vue2-timepicker/dist/VueTimepicker.css';

/* Or, with node_module alias path like: */
@import '~vue2-timepicker/dist/VueTimepicker.css';
</style>



// WEBPACK FOOTER //
// src/components/HRM/CheckINOUT/ManageCheckINOUTAdjust.vue